// components/PageShell.js
// Shared page wrapper for consistent scroll and bottom-nav spacing

import React from "react";

export default function PageShell({ children, style }) {
  return (
    <div style={{ overflowY: "auto", paddingBottom: 96, width: "100%", height: "100%", ...style }}>
      {children}
    </div>
  );
}
